import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import cartStore from "./cartStore.js";
import language from "./lang.js";
import loaderStore from "./loader.js";
import drawerSlice from "./slice";
import userData from "./userStore.js";

import validateCartMiddleware from "./validateCartPayload";

const persistConfig = {
  key: "rise",
  storage,
};

const rootReducer = combineReducers({
  isOpen: drawerSlice,
  user: userData,
  lang: language,
  isLoader: loaderStore,
  cart: cartStore,
});

export const store = configureStore({
  reducer: persistReducer(persistConfig, rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }).concat(validateCartMiddleware),
});

export const persistor = persistStore(store);
